import {resetPassword} from "aws-amplify/auth"

export default async function sendConfirmationCode(email) {
    try {
        return await resetPassword({username: email})
    } catch (error) {
        console.error("resetPassword: ", error)
        return {error: true, name: error.name, message: error.message}
    }
}